import { KnmPublishStatusesEnum } from 'APIPackage/KnmModule/enums/KnmPublishStatusesEnum';
import { IPublishedStatusSelectOption } from 'CorePackage/MainModule/interfaces/IPublishedStatusSelectOption';

export const publishedStatusesCodesNamesMap = {
  [KnmPublishStatusesEnum.UNPUBLISHED]: 'Не опубликовано',
  [KnmPublishStatusesEnum.ASK_TO_PUBLISH]: 'Ожидает публикации',
  [KnmPublishStatusesEnum.PUBLISHED]: 'Опубликовано',
  [KnmPublishStatusesEnum.PUBLISH]: 'Опубликовано',
  [KnmPublishStatusesEnum.ASK_TO_UNPUBLISH]: 'Ожидает отзыва',
};

export const publishedStatusesSelectOptions: IPublishedStatusSelectOption[] = [
  {
    id: 1,
    label: publishedStatusesCodesNamesMap[KnmPublishStatusesEnum.UNPUBLISHED],
    value: KnmPublishStatusesEnum.UNPUBLISHED,
  },
  {
    id: 2,
    label: publishedStatusesCodesNamesMap[KnmPublishStatusesEnum.ASK_TO_PUBLISH],
    value: KnmPublishStatusesEnum.ASK_TO_PUBLISH,
  },
  {
    id: 3,
    label: publishedStatusesCodesNamesMap[KnmPublishStatusesEnum.PUBLISHED],
    value: KnmPublishStatusesEnum.PUBLISHED,
  },
  {
    id: 4,
    label: publishedStatusesCodesNamesMap[KnmPublishStatusesEnum.ASK_TO_UNPUBLISH],
    value: KnmPublishStatusesEnum.ASK_TO_UNPUBLISH,
  },
];
